import { dispatchAddToCartSync } from '@/shared/add-to-cart/add-to-cart';

let searchResultsBasketSyncAttached = false;

function getQuantityForSearchCardId(cardIdStr, basketItems) {
	let sum = 0;
	if (!basketItems || typeof basketItems !== 'object') {
		return sum;
	}
	for (const key in basketItems) {
		if (!Object.prototype.hasOwnProperty.call(basketItems, key)) {
			continue;
		}
		const item = basketItems[key];
		if (!item || item.isDeleted) {
			continue;
		}
		const pid = item.productId != null ? String(item.productId) : '';
		const parentPid = item.parentProductId != null ? String(item.parentProductId) : '';
		if (pid === cardIdStr || parentPid === cardIdStr) {
			const q = parseFloat(item.quantity);
			sum += Number.isNaN(q) ? 0 : q;
		}
	}
	return sum;
}

function applyExternalBasketToSearchResultCards(basketData) {
	if (!basketData || !basketData.basketItems) {
		return;
	}

	const cards = document.querySelectorAll('#modal-search .js-search-result__items .card-product');

	cards.forEach((card) => {
		const idInput = card.querySelector('input[name="product-id"]');
		if (!idInput) {
			return;
		}

		const addToCart = card.querySelector('.js-add-to-cart');
		if (!addToCart) {
			return;
		}

		const counterInput = addToCart.querySelector('.counter__input');
		if (!counterInput) {
			return;
		}

		const qty = getQuantityForSearchCardId(String(idInput.value), basketData.basketItems);

		addToCart.dataset.cartQuantity = String(qty);
		dispatchAddToCartSync(addToCart, qty);
	});
}

function attachSearchResultsBasketSyncOnce() {
	if (searchResultsBasketSyncAttached) {
		return;
	}
	if (typeof window.BX === 'undefined' || !window.BX.Event || !window.BX.Event.EventEmitter) {
		return;
	}

	searchResultsBasketSyncAttached = true;

	window.BX.Event.EventEmitter.subscribe('o2k:basket:externalBasketDataUpdate', (event) => {
		const basketData = event && event.data && event.data.basketData;
		if (basketData) {
			applyExternalBasketToSearchResultCards(basketData);
		}
	});
}

export function renderSearchResults(container, results) {
	if (!container) return;

	attachSearchResultsBasketSyncOnce();

	container.innerHTML = '';

	results.product.forEach((product) => {
		const productCard = document.createElement('article');
		productCard.className = 'card-product';

		// Product id
		const idInput = document.createElement('input');
		idInput.type = 'hidden';
		idInput.name = 'product-id';
		idInput.value = product.id;
		productCard.appendChild(idInput);

		// Product gallery
		const gallery = document.createElement('div');
		gallery.className = 'card-product-gallery js-card-product-gallery';
		const swiper = document.createElement('div');
		swiper.className = 'swiper card-product-gallery__swiper js-card-product-gallery__swiper';
		const wrapper = document.createElement('div');
		wrapper.className = 'swiper-wrapper';
		product.images.forEach((image) => {
			const slide = document.createElement('div');
			slide.className = 'swiper-slide';
			const img = document.createElement('img');
			img.src = image;
			img.alt = product.name;
			img.loading = 'lazy';
			slide.appendChild(img);
			wrapper.appendChild(slide);
		});
		swiper.appendChild(wrapper);
		gallery.appendChild(swiper);
		const pagination = document.createElement('div');
		pagination.className = 'card-product-gallery__pagination swiper-pagination js-card-product-gallery__pagination';
		gallery.appendChild(pagination);
		productCard.appendChild(gallery);

		// Product main section
		const main = document.createElement('div');
		main.className = 'card-product__main';
		main.innerHTML = `
			<hgroup class="card-product__hgroup">
				<h3 class="card-product__title truncate-box">${product.name}</h3>
				<p class="card-product__sku">Артикул: ${product.sku}</p>
			</hgroup>
		`;
		productCard.appendChild(main);

		// Product aside section
		const aside = document.createElement('div');
		const addToCart = document.createElement('div');
		addToCart.className = 'card-product__cart-wrapper add-to-cart js-add-to-cart';
		if (product.inCart > 0) addToCart.classList.add('add-to-cart--active');
		if (product.inStock > 0 && product.canBuy) {
			addToCart.innerHTML = `
				<button class="card-product__cart-button button add-to-cart__button js-add-to-cart__button">
					<span>В корзину</span>
				</button>
				<div class="counter card-product__cart-counter js-counter add-to-cart__counter js-add-to-cart__counter">
					<button class="counter__button counter__button--dec button button--white" type="button" data-type="dec">
						<i class="icon icon-minus"></i>
					</button>
					<input class="counter__input" type="number" name="counter" value=${product.inCart} max=${product.inStock}>
					<button class="counter__button counter__button--inc button button--white" type="button" data-type="inc">
						<i class="icon icon-plus"></i>
					</button>
				</div>
				<button class="card-product__fav-button button button--white js-card-product-fav ${product.inFav && 'card-product__fav-button--active'}" aria-label="В избранное">
					<i class="icon icon-heart"></i>
					<i class="icon icon-heart-filled"></i>
				</button>
			`;
		} else {
			addToCart.innerHTML = `
				<button class="card-product__cart-button button add-to-cart__button js-modal-open" data-modal="#modal-callback">
					<span>Цена по запросу</span>
				</button>
				<button class="card-product__fav-button button button--white js-card-product-fav ${product.inFav && 'card-product__fav-button--active'}" aria-label="В избранное">
					<i class="icon icon-heart"></i>
					<i class="icon icon-heart-filled"></i>
				</button>
			`;
		}
		aside.className = 'card-product__aside';
		const priceTemplate = `
			<div class="card-product__price-wrapper">
			<div class="card-product__price">${product.price} <span>руб./шт</span></div>
			<div class="card-product__price-date">Цена от ${product.priceDate}</div>
			</div>
		`;
		aside.innerHTML = `
			${Number(product.price) !== 0 ? priceTemplate : ''}
			<hgroup class="card-product__hgroup card-product__hgroup--aside">
				<h3 class="card-product__title truncate-box">
					<a href="${product.href}" class="link link--black">${product.name}</a>
				</h3>
				<p class="card-product__sku">Артикул: ${product.sku}</p>
			</hgroup>
		`;
		aside.appendChild(addToCart);
		productCard.appendChild(aside);

		container.appendChild(productCard);
	});

	requestAnimationFrame(() => {
		container.querySelectorAll('.card-product').forEach((card) => {
			window.app.cardProductInit(card);
			initCardListeners(card);
		});
	});
}

function initCardListeners(card) {
	attachSearchResultsBasketSyncOnce();

	const cardID = card.querySelector('input[name="product-id"]')?.value;
	if (!cardID) return;

	const favButton = card.querySelector('.js-card-product-fav');
	if (favButton) favButton.addEventListener('click', (e) => handleFavButtonClick(e, cardID));

	const addToCart = card.querySelector('.js-add-to-cart');
	if (addToCart) {
		addToCart.addEventListener('change', (e) => handleCartChange(e, cardID));
		addToCart.addEventListener('remove', (e) => handleCartRemove(e, cardID));
	}
}
function handleFavButtonClick(e, cardID) {
	const favButton = e.currentTarget;
	const inFav = favButton.classList.contains('card-product__fav-button--active');

	favButton.dispatchEvent(
		new CustomEvent('search:toggleFav', {
			bubbles: true,
			detail: { id: cardID, inFav },
		}),
	);
}

function handleCartChange(e, cardID) {
	const addToCart = e.currentTarget;
	const counterInput = addToCart.querySelector('.counter__input');

	const prevQuantity = Number(addToCart.dataset.cartQuantity ?? 0);
	const inCart = Number(counterInput?.value ?? 0);

	addToCart.dataset.cartQuantity = String(inCart);

	if (prevQuantity === 0 && inCart === 1) {
		addToCart.dispatchEvent(
			new CustomEvent('search:addedToCart', {
				bubbles: true,
				detail: { id: cardID, inCart },
			}),
		);
		return;
	}

	if (inCart > 0 && prevQuantity !== inCart) {
		addToCart.dispatchEvent(
			new CustomEvent('search:inCartQuantityChanged', {
				bubbles: true,
				detail: { id: cardID, inCart },
			}),
		);
	}
}

function handleCartRemove(e, cardID) {
	const addToCart = e.currentTarget;

	addToCart.dataset.cartQuantity = '0';

	addToCart.dispatchEvent(
		new CustomEvent('search:removedFromCart', {
			bubbles: true,
			detail: { id: cardID, inCart: 0 },
		}),
	);
}
